import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Field} from 'redux-form';
import {Grid, Input} from 'semantic-ui-react';
import {setErrorMessage, clearErrorMessage} from '../../../../../../common/components/form/common';
import {hasAccessPermission} from '../../../../../../common/permissions/validations';
import {resources, scopes} from '../../../../../../common/permissions/dictionary';

class ItemRow extends Component {
  renderField(name, type, submitErrors) {
    return (
      <div>
        <Field
          name={`${name}${type}`}
          component={Input}
          required
          maxLength='10'
          type='number'
          min='0'
          step='0.01'
          pattern='^\d+(?:\.\d{1,2})?$'
          disabled={
            !hasAccessPermission(
              this.props.permissions,
              resources.IccMatrixParameters,
              scopes.Edit
            )
          }
          onInvalid={(event) =>
            setErrorMessage(
              'Por favor, llene este campo siguiendo el formato 0.00',
              event
            )
          }
          onInput={(event) => clearErrorMessage(event)}
        />
        {submitErrors && submitErrors[`${name}${type}`] && (
          <p className='error'>{submitErrors[`${name}${type}`]}</p>
        )}
      </div>
    );
  }

  render() {
    const {submitErrors} = this.props;
    return (
      <Grid.Row columns={6}>
        <Grid.Column width={1} className={this.props.className}>
          <b>{this.props.title}</b>
        </Grid.Column>
        <Grid.Column width={4}>
          {this.renderField(this.props.name, 'Min', submitErrors)}
        </Grid.Column>
        <Grid.Column width={2}>
          <b>&le;</b>
        </Grid.Column>
        <Grid.Column width={3}>
          <b>{this.props.category}</b>
        </Grid.Column>
        <Grid.Column width={2}>
          <b>&lt;</b>
        </Grid.Column>
        <Grid.Column width={4}>
          {this.renderField(this.props.name, 'Max', submitErrors)}
        </Grid.Column>
      </Grid.Row>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'permissions': state.session.permissions,
  };
};

export default connect(mapStateToProps, {})(ItemRow);
